export default __webpack_public_path__ + "static/media/valley5.7789ea1a.png";